'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () {
						return e[k];
					}
				});
			}
		});
	}
	n['default'] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgMail = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 20
}, props), _defs || (_defs = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
  id: "mail_svg__a"
}, /*#__PURE__*/React__namespace.createElement("path", {
  d: "M0 0h24v20H0z"
})))), /*#__PURE__*/React__namespace.createElement("g", {
  style: {
    clipPath: "url(#mail_svg__a)"
  }
}, /*#__PURE__*/React__namespace.createElement("path", {
  style: {
    fill: "#fff"
  },
  d: "M0 0h24v20H0z"
}), /*#__PURE__*/React__namespace.createElement("path", {
  d: "M-90.743 412.7h-20.114a2.073 2.073 0 0 0-1.943 2.073v15.854a2.073 2.073 0 0 0 1.943 2.073h20.114a2.073 2.073 0 0 0 1.943-2.073v-15.854a2.073 2.073 0 0 0-1.943-2.073Zm-2.286 4.634-7.429 5.976a.654.654 0 0 1-.457.122.654.654 0 0 1-.457-.122l-7.429-5.976a.807.807 0 0 1-.114-1.1.694.694 0 0 1 1.029-.122l6.971 5.61 6.971-5.61a.693.693 0 0 1 1.029.122.714.714 0 0 1-.114 1.1Z",
  transform: "translate(112.8 -412.7)",
  style: {
    fill: "#1d66dd"
  }
})));

module.exports = SvgMail;
//# sourceMappingURL=mail.svg.js.map
